/* tslint:disable */

declare var Object: any;
export interface InvoiceRefundInterface {
  "invoice_id": number;
  "credit_note_id": number;
  "id"?: number;
}

export class InvoiceRefund implements InvoiceRefundInterface {
  "invoice_id": number;
  "credit_note_id": number;
  "id": number;
  constructor(data?: InvoiceRefundInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `InvoiceRefund`.
   */
  public static getModelName() {
    return "InvoiceRefund";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of InvoiceRefund for dynamic purposes.
  **/
  public static factory(data: InvoiceRefundInterface): InvoiceRefund{
    return new InvoiceRefund(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'InvoiceRefund',
      plural: 'InvoiceRefunds',
      path: 'InvoiceRefunds',
      idName: 'id',
      properties: {
        "invoice_id": {
          name: 'invoice_id',
          type: 'number'
        },
        "credit_note_id": {
          name: 'credit_note_id',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
